import '../Assets/css/servicios.css';
import busIcon from "../Assets/icon/IconServicios/IconServ-01.svg";
import minibusIcon from "../Assets/icon/IconServicios/IconServ-02.svg";
import peopleTransferIcon from "../Assets/icon/IconServicios/IconServ-03.svg";
import pickupIcon from "../Assets/icon/IconServicios/IconServ-04.svg";
import ticketsIcon from "../Assets/icon/IconServicios/IconServ-05.svg";
import busRouteIcon from "../Assets/icon/IconServicios/IconServ-06.svg";
import minibusRouteIcon from "../Assets/icon/IconServicios/IconServ-07.svg";
import transportServiceIcon from "../Assets/icon/IconServicios/IconServ-08.svg";

export const Servicios = () => {
    const services = [
        { icon: busIcon, title: "Transporte interno con buses y minibuses dentro de faena." },
        { icon: minibusIcon, title: "Arriendo de buses, taxibus y minibuses para interior faena." },
        { icon: peopleTransferIcon, title: "Traslado de personal desde la ciudad a la faena minera en cambio de turnos." },
        { icon: pickupIcon, title: "Arriendo de camionetas 4x4." },
        { icon: ticketsIcon, title: "Convenios de pasajes para empresas, con tarifas preferenciales." },
        { icon: busRouteIcon, title: "Convenios de buses de acercamiento para facilitar el transporte desde diferentes puntos hacia la faena." },
        { icon: minibusRouteIcon, title: "Convenios de minibuses para cambios de turno, asegurando traslados más específicos y personalizados." },
        { icon: transportServiceIcon, title: "Servicio de transporte para cambios de turno, asegurando una logística eficiente y puntual." }
    ];


    return (
        <div className="services" id="servicios">
            <h1>Servicios</h1>
            <div className="services-container">
                {services.map((service, index) => (
                    <div key={index} className="service-card">
                        <img src={service.icon} alt={service.title}/>
                        <p>{service.title}</p>
                    </div>
                ))}
            </div>
        </div>

    );
}